import React, { useCallback, useEffect, useMemo, useState } from "react";
import {
  FaArrowLeft,
  FaHandshake,
  FaSearch,
  FaSpinner,
} from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import useApp from "../../hooks/useAppContext";
import useAuth from "../../hooks/useAuthContext";
import LinhaMM from "./linhaMM";
import "../adm/admPatrocinadoresList.css";
import "../adm/adm.css";
import "./recepcao.css";

function obterNomePatrocinador(evento) {
  const participantes =
    evento?.participantes || evento?.agenda?.participantes || [];

  const patrocinador = participantes.find((p) => {
    const usuario = p?.usuario;
    if (!usuario) return false;
    if (usuario.tipo === "patrocinador") return true;
    return Boolean(usuario.id_patrocinador);
  });

  return (patrocinador?.usuario?.nome || "").trim();
}

function MM() {
  const navigate = useNavigate();
  const { usuario } = useAuth();
  const { setMostraMenuAdm, getReunioesNegocio } = useApp();

  const [reunioes, setReunioes] = useState([]);
  const [filtro, setFiltro] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    setMostraMenuAdm(false);
  }, [setMostraMenuAdm]);

  const carregarReunioes = useCallback(async () => {
    if (!usuario) return;

    setIsLoading(true);
    setError(null);
    try {
      const auxEventos = (await getReunioesNegocio()) || [];
      const eventosMM = auxEventos.filter(
        (evento) =>
          evento.tipo === "m_m" || evento.agenda?.tipo === "m_m"
      );

      const ordenacao = [...eventosMM].sort((a, b) => {
        const nomeA = obterNomePatrocinador(a);
        const nomeB = obterNomePatrocinador(b);
        const porNome = nomeA.localeCompare(nomeB, "pt-BR", {
          sensitivity: "base",
        });
        if (porNome !== 0) return porNome;

        const dataA = new Date(
          a.dt_hora_inicio ? a.dt_hora_inicio : a.agenda?.dt_hora_inicio
        );
        const dataB = new Date(
          b.dt_hora_inicio ? b.dt_hora_inicio : b.agenda?.dt_hora_inicio
        );
        return dataA - dataB;
      });

      setReunioes(ordenacao);
    } catch (err) {
      console.error("Erro ao carregar eventos M&M:", err);
      setError("Erro ao carregar as reuniões Match & Meet.");
      setReunioes([]);
    } finally {
      setIsLoading(false);
    }
  }, [usuario, getReunioesNegocio]);

  useEffect(() => {
    carregarReunioes();
  }, [carregarReunioes]);

  const reunioesFiltradas = useMemo(() => {
    if (!filtro.trim()) return reunioes;
    const termo = filtro.toLowerCase().trim();
    return reunioes.filter((item) => {
      const participantes = item.participantes || item.agenda?.participantes || [];
      const nomes = participantes
        .map((p) => p?.usuario?.nome || p?.usuario?.empresa || "")
        .join(" ");
      const campos = [item.nome, item.agenda?.nome, nomes];
      return campos.some((campo) =>
        String(campo || "")
          .toLowerCase()
          .includes(termo)
      );
    });
  }, [reunioes, filtro]);

  return (
    <div className="apl-page apl-page--padded recepcao-page mm-page">
      <header className="apl-header" aria-label="Cabeçalho Match & Meet">
        <div className="apl-header-text">
          <h1>
            <FaHandshake size={22} aria-hidden style={{ marginRight: 8 }} />
            Match & Meet
          </h1>
          <p>
            Confira todas as reuniões M&M e faça o check-in dos participantes via
            QR Code.
          </p>
        </div>

        <div className="apl-toolbar apl-toolbar--inline">
          <div className="apl-search">
            <span className="apl-search-icon" aria-hidden>
              <FaSearch size={14} />
            </span>
            <input
              type="search"
              className="apl-search-input"
              placeholder="Buscar por participante…"
              value={filtro}
              onChange={(e) => setFiltro(e.target.value)}
              disabled={isLoading}
              aria-label="Buscar reuniões M&M"
            />
          </div>

          <div className="apl-toolbar-actions">
            <Link to="/private/adm/recepcao" className="apl-btn apl-btn--secondary">
              Recepção
            </Link>
            <button
              type="button"
              className="apl-btn apl-btn--ghost"
              onClick={() => navigate(-1)}
              title="Voltar"
            >
              <FaArrowLeft size={14} aria-hidden />
              Voltar
            </button>
          </div>
        </div>
      </header>

      <div className="body-tela-adm" style={{ paddingBottom: 0 }}>
        {error ? (
          <div className="apl-alert" role="alert">
            {error}
          </div>
        ) : null}

        {!isLoading && reunioes.length > 0 ? (
          <p className="mm-contagem" aria-live="polite">
            {reunioesFiltradas.length} reunião
            {reunioesFiltradas.length === 1 ? "" : "ões"} M&M
          </p>
        ) : null}

        {isLoading ? (
          <div className="apl-card">
            <div className="apl-loading">
              <FaSpinner className="fa-spin" size={28} aria-hidden />
              <span>Carregando reuniões Match & Meet…</span>
            </div>
          </div>
        ) : (
          <section className="apl-card" aria-label="Lista de reuniões M&M">
            {reunioesFiltradas.length === 0 ? (
              <div className="apl-empty">
                <p className="apl-empty-title">
                  {reunioes.length === 0
                    ? "Nenhuma reunião M&M"
                    : "Nenhum resultado"}
                </p>
                <p style={{ margin: 0 }}>
                  {reunioes.length === 0
                    ? "Aguarde novos agendamentos Match & Meet."
                    : "Ajuste a busca para ver as reuniões."}
                </p>
              </div>
            ) : (
              <div className="area-lista-reunioes recepcao-lista">
                {reunioesFiltradas.map((r, index) => (
                  <LinhaMM
                    key={r.id || `mm-${index}`}
                    item={r}
                    handle={carregarReunioes}
                  />
                ))}
              </div>
            )}
          </section>
        )}
      </div>
    </div>
  );
}

export default MM;
